import FormikTextField from 'components/TextFieldFormik'
import Slider from 'components/Slider'

import {
    dall_e2SizesOptions,
    dall_e3SizesOptions,
    imageModelsOptions,
    qualityOptions,
    samplersOptions,
    styleOptions,
} from '../types'

import DropdownFormik from 'components/DropdownFormik'
import { useEffect, useState } from 'react'

const getSizeOptions = (model: string) => {
    switch (model) {
        case 'dall-e-3':
            return dall_e3SizesOptions
        case 'dall-e-2':
            return dall_e2SizesOptions
        default:
            return []
    }
}

const ImageResponseSettings = ({ formik }: { formik: any }) => {
    const [sizeOptions, setSizeOptions] = useState(getSizeOptions(formik.values.image_model))

    useEffect(() => {
        const newSizeOptions = getSizeOptions(formik.values.image_model)
        formik.setFieldValue('size', newSizeOptions[0]?.value || '')
        setSizeOptions(newSizeOptions)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.image_model])

    return (
        <>
            <FormikTextField name='seed' placeholder={'seed'} label={'Seed'} type='number' />

            <DropdownFormik
                label={'Model'}
                fieldName={'image_model'}
                fieldValue={formik.values.image_model}
                options={imageModelsOptions}
                setFieldValue={formik.setFieldValue}
            />

            <DropdownFormik
                label={'Size'}
                fieldName={'size'}
                fieldValue={formik.values.size}
                options={sizeOptions}
                setFieldValue={formik.setFieldValue}
            />

            <DropdownFormik
                label={'Quality'}
                fieldName={'quality'}
                fieldValue={formik.values.quality}
                options={qualityOptions}
                setFieldValue={formik.setFieldValue}
            />

            <DropdownFormik
                label={'Style'}
                fieldName={'style'}
                fieldValue={formik.values.style}
                options={styleOptions}
                setFieldValue={formik.setFieldValue}
            />

            <FormikTextField
                name='cfg_scale'
                placeholder={'cfg_scale'}
                label={'cfg scale'}
                type='number'
            />
            <FormikTextField
                name='samples'
                placeholder={'samples'}
                label={'Samples'}
                type='number'
            />
            <DropdownFormik
                label={'Sampler'}
                fieldName={'sampler'}
                fieldValue={formik.values.sampler}
                options={samplersOptions}
                setFieldValue={formik.setFieldValue}
            />
            <Slider
                label='Steps'
                value={formik.values.steps}
                onChange={value => formik.setFieldValue('steps', value)}
                min={1}
                max={50}
                step={1}
                name={'steps'}
            />
        </>
    )
}

export default ImageResponseSettings
